module.exports = __webpack_public_path__ + "static/media/galaxy.c21e3868.svg";